import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    userName: state.context.session.userName,
    userLabel: state.context.session.userLabel,
    currentUserIsGuest: getCurrentUserIsGuest(state),
});

const mapDispatchToProps = {
    signOut,
};

export interface GreetUserStyles {
    greetWrapper?: InjectableCss;
}

const styles: GreetUserStyles = {
    greetWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            position: absolute;
            top: -28px;
            left: -20px;
            span {
                font-style: italic;
                padding: 5px 0;
                font-weight: 600;
                text-transform: capitalize;
                font-size: 13px;
                color: #353432;
            }
        `,
    },
};

interface OwnProps extends WidgetProps { }

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;
export const GreetUserStyles = styles;

const GreetUser: FC<Props> = ({ userName, userLabel, currentUserIsGuest }) => {
    let firstName = "";
    if (userName && !currentUserIsGuest) {
        const fullName = userLabel.split(" ");
        firstName = fullName[0];
    }

    return (
        <StyledWrapper {...styles.greetWrapper} data-test-selector="Greetings">
            {userName && !currentUserIsGuest && <span>Welcome, {firstName} !</span>}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(GreetUser)),
    definition: {
        displayName: "Greet User",
        group: "Common",
    },
};

export default widgetModule;
